package components.identity.verification

import csstype.*
import emotion.react.css
import kotlinx.js.jso
import mui.material.*
import react.FC
import react.Props
import react.dom.html.ReactHTML
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.h1
import react.dom.html.ReactHTML.img
import react.dom.html.ReactHTML.p

@JsNonModule
@JsModule("./images/identity-verification-success.png")
external val idCheckSuccessImage: dynamic

external interface IdentityVerificationDisclaimerProps : Props {
	var show: Boolean
	var verifyIdentityPressed: () -> Unit
	var logoutPressed: () -> Unit
}

val IdentityVerificationDisclaimer = FC<IdentityVerificationDisclaimerProps>("identityVerificationDisclaimer") { props ->
	div {
		className = ClassName("section no-top-bottom")
		div {
			id = "identity-verification-failure-container"
			className = ClassName("container text-center padding")
			style = jso {
				display = if (props.show) Display.block else None.none
			}
			IdentityVerificationDisclaimerTitle {}

			div {
				style = jso {
					paddingTop = 30.px
				}
				img {
					css {
						borderRadius = 8.px
					}
					alt = "Identity Verification Success image"
					src = idCheckSuccessImage
				}
			}
			p {
				className = ClassName("float-middle")
				style = jso {
					maxWidth = 380.px
					paddingTop = 30.px
				}
				ReactHTML.span {
					className = ClassName("text-white font-weight-600")
					+"Open Tab "
				}
				+"Before opening a Tab at this place, we require to verify your identity."
			}
			p {
				className = ClassName("small text-grey no-bottom")
				style = jso {
					paddingTop = 30.px
				}
				+"This verification process is provided and operated through a secure identity verification provider."
			}

			div {
				div {
					style = jso {
						paddingTop = 30.px
					}
					ReactHTML.button {
						className = ClassName("btn white")
						onClick = {
							it.preventDefault()
							props.verifyIdentityPressed()
						}
						+"Start"
					}
				}
				div {
					style = jso {
						paddingTop = 15.px
					}
					ReactHTML.button {
						className = ClassName("btn no-animation small outline white")
						onClick = {
							it.preventDefault()
							props.logoutPressed()
						}
						+"Log Out"
					}
				}
			}
		}
	}
}

val IdentityVerificationDisclaimerTitle = FC<Props> {
	div {
		className = ClassName("container text-center")
		h1 {
			className = ClassName("big float-middle no-bottom")
			style = jso {
				maxWidth = 420.px
			}
			+"Identity Verification Required"
		}
	}
}

